/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Person from '../cards/Person';
import Title from '../typography/Title';

import styles from '../../../styles/partials/credits.module.css';

const propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    credits: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
};

function Credits({ title = null, credits = null, className }) {
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {title !== null ? (
                <Title className={styles.title} size="small">
                    {title}
                </Title>
            ) : null}
            <div className={styles.credits}>
                {(credits || []).map((credit) => {
                    const { person = null, roles = [], description = null } = credit || {};
                    const finalItem =
                        description !== null ? { ...person, bio: description } : person;
                    return (
                        <div key={`credit-person-${person?.id}`} className={styles.credit}>
                            <Person item={finalItem} roles={roles} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

Credits.propTypes = propTypes;

export default Credits;
